module.exports = __webpack_public_path__ + "img/top_popularity@3x.129fe52e.png";